import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CalmeanDataService } from '../services/calmean-data.service';

/**
 * Interceptor to add authentication token to outgoing requests
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private calmeanDataService: CalmeanDataService) {}

  /**
   * Intercept HTTP requests and add authentication token
   * @param request The outgoing request
   * @param next The next handler
   * @returns Observable of HTTP event
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Get token from service
    const token = this.calmeanDataService.getToken();

    // If token exists, clone the request and add the token
    if (token) {
      const authReq = request.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      // Pass the cloned request with token to the next handler
      return next.handle(authReq);
    }

    // If no token, pass the original request to the next handler
    return next.handle(request);
  }
}
